export default "__VITE_PUBLIC_ASSET__4d9801af__"